import React from "react";
import InvoiceDetail from "./InvoiceDetail";
import InvoiceList from "./InvoiceList";
import InvoicePrint from "./InvoicePrint";

const Invoice = () => {
  return (
    <div>
      {/* <InvoiceDetail/> */}
      <InvoiceList />
      {/* <InvoicePrint /> */}
    </div>
  );
};

export default Invoice;
